import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
var uiKitInstanceId = null;
var count = 0;
var GLOBAL_INSTANCE_KEY = '__ui_kit_instance_count__';

/**
 * Хук для создания опциональных идентификаторов на клиенте
 */
function useId(id) {
  var _React$useState = React.useState(id),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    defaultId = _React$useState2[0],
    setDefaultId = _React$useState2[1];
  React.useEffect(function () {
    if (!defaultId) {
      if (uiKitInstanceId === null) {
        window[GLOBAL_INSTANCE_KEY] = window[GLOBAL_INSTANCE_KEY] || 0;
        uiKitInstanceId = window[GLOBAL_INSTANCE_KEY]++;
      }
      setDefaultId("ui-kit-".concat(uiKitInstanceId, "-").concat(count++));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Сначала попытаемся вернуть id из аргумента
  // Потому что обновление через эффект требует лишнего ререндера
  return id || defaultId;
}
export { useId };